module.exports = __webpack_public_path__ + "static/img/strona_010.1640e5d5.jpg";